// extracted by mini-css-extract-plugin
module.exports = {"container":"tooltip_container__2tJUP","label":"tooltip_label__3LoUu","icon":"tooltip_icon__1Deqn","value":"tooltip_value__3DiVc"};